import { SET_CARD_HEIGHT } from 'client/constants/actions';

/**
 * @param payload {Number} card content height
 * @return {{type: *, payload: *}}
 */
export function setCardHeight(payload: number) {
	return {
		type: SET_CARD_HEIGHT,
		payload,
	};
}
